import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AboutUsLayer from "../components/AboutUsLayer";

const AboutUsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="About Us" />

        {/* TermsConditionLayer */}
        <AboutUsLayer />
      </MasterLayout>
    </>
  );
};

export default AboutUsPage;
